import { KButton, KSpan, KTitleSpan } from "kahuna-base-react-components"
import React, { useEffect, useState } from "react"
import { RootState } from "../../../store"
import { connect } from "react-redux"
import { Dialog } from "@headlessui/react"
import { useNavigate } from "react-router-dom"
import { lang } from "../../../constants/languages"

const UnreadNotificationModal = ({ unreadNotificationsNumber }: { unreadNotificationsNumber: number }) => {
  const [open, setOpen] = useState<boolean>(false)
  const navigate = useNavigate()

  useEffect(() => {
    if (unreadNotificationsNumber > 0) {
      setOpen(true)
    }
  }, [])

  return (
    <Dialog open={open} onClose={() => setOpen(false)}>
      <div
        className="fixed w-screen h-screen top-0 left-0 flex items-center justify-center bg-[#0000004d]"
        style={{ zIndex: 9999 }}
        onClick={() => {
          setOpen(false)
        }}
      >
        <div className="p-6 shadow-md rounded-[10px] bg-[#fff] flex flex-col items-start justify-center">
          <KTitleSpan text={lang.notifications.title} lineHeight="22px" fontSize={20} />
          <div className="mt-7 flex flex-row items-center gap-2">
            <KSpan text={lang.notifications.unread_notifications} />
          </div>

          <div className="flex w-full mt-10 items-center justify-center">
            <KButton
              width="auto"
              background="black"
              textColor="white"
              text={lang.notifications.view_notifications_button}
              onClick={() => {
                navigate("/notifications")
                setOpen(false)
              }}
            />
          </div>
        </div>
      </div>
    </Dialog>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    unreadNotificationsNumber: state.notifications.unreadNotificationsNumber
  }
}

export default connect(mapStateToProps)(UnreadNotificationModal)
